import { render } from "./operatorIconGray.vue?vue&type=template&id=1a881452&ts=true"
import script from "./operatorIconGray.vue?vue&type=script&lang=ts"
export * from "./operatorIconGray.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__